// @ts-nocheck
if (!customElements.get("td-tab-select")) {
  class TdTabSelect extends HTMLElement {
    constructor() {
      super();
      
      this.activeIndex = 0;
      
      // Store event handler references for cleanup
      this.tabHandlers = new Map();
      this.accordionHandlers = new Map();
    }

    connectedCallback() {
      // Query DOM elements fresh each time component is connected
      this.tabs = Array.from(this.querySelectorAll('[data-button-index]'));
      this.contents = Array.from(this.querySelectorAll('[data-content-index]'));
      this.images = Array.from(this.querySelectorAll('[data-image-index]'));
      this.accordionToggles = Array.from(this.querySelectorAll('[data-accordion-toggle]'));

      // Only setup if not already initialized
      if (this.tabHandlers.size === 0) {
        this.setupTabs(this.tabs);
      }
      if (this.accordionHandlers.size === 0) {
        this.setupAccordions(this.accordionToggles);
      }
      this.updateActiveTab(this.activeIndex);
    }

    disconnectedCallback() {
      // Remove all tab event listeners
      this.tabHandlers.forEach((handler, tab) => {
        tab.removeEventListener('click', handler);
      });
      this.tabHandlers.clear();

      // Remove all accordion event listeners
      this.accordionHandlers.forEach((handler, header) => {
        header.removeEventListener('click', handler);
      });
      this.accordionHandlers.clear();
    }

    setupTabs(tabs) {
      tabs.forEach((tab) => {
        const handler = () => {
          const index = parseInt(tab.dataset.buttonIndex, 10);
          this.updateActiveTab(index);
        };
        
        tab.addEventListener('click', handler);
        this.tabHandlers.set(tab, handler);
      });
    }

    setupAccordions(toggles) {
      toggles.forEach((toggle) => {
        const accordionItem = toggle.closest('[data-accordion-item]');
        if (!accordionItem) return;

        const header = accordionItem.querySelector('.td-ts__feature-header');
        if (!header) return;

        // Create handler function that can be removed later
        const handler = (e) => {
          e.preventDefault();
          this.toggleAccordion(toggle);
        };

        // Add click listener to the entire header
        header.addEventListener('click', handler);
        this.accordionHandlers.set(header, handler);

        // Make header cursor pointer to indicate it's clickable
        header.style.cursor = 'pointer';
      });
    }

    toggleAccordion(toggle) {
      const accordionItem = toggle.closest('[data-accordion-item]');
      if (!accordionItem) return;

      const content = accordionItem.querySelector('[data-accordion-content]');
      const plusIcon = toggle.querySelector('.td-ts__toggle-icon--plus');
      const minusIcon = toggle.querySelector('.td-ts__toggle-icon--minus');
      
      if (!content || !plusIcon || !minusIcon) return;

      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      // Toggle aria-expanded
      toggle.setAttribute('aria-expanded', !isExpanded);

      // Toggle content
      content.classList.toggle('is-expanded', !isExpanded);

      // Toggle icons with CSS classes
      plusIcon.classList.toggle('is-hidden', !isExpanded);
      minusIcon.classList.toggle('is-hidden', isExpanded);
    }

    updateActiveTab(index) {
      if (index < 0 || index >= this.tabs.length) {
        console.error('Invalid tab index:', index);
        return;
      }

      this.activeIndex = index;

      this.tabs.forEach((tab) => {
        const isActive = parseInt(tab.dataset.buttonIndex, 10) === index;
        tab.classList.toggle('tab-button--active', isActive);
        tab.classList.toggle('tab-button-inactive', !isActive);
        // Update ARIA attributes
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.contents.forEach((content) => {
        const isActive = parseInt(content.dataset.contentIndex, 10) === index;
        content.classList.toggle('td-ts__content-active', isActive);
        content.classList.toggle('td-ts__content-inactive', !isActive);
        // Update hidden attribute for accessibility
        if (isActive) {
          content.removeAttribute('hidden');
        } else {
          content.setAttribute('hidden', '');
        }
      });

      this.images.forEach((image) => {
        const isActive = parseInt(image.dataset.imageIndex, 10) === index;
        image.classList.toggle('td-ts__image-active', isActive);
        image.classList.toggle('td-ts__image-inactive', !isActive);
      });

      // Close all accordions when switching tabs
      this.closeAllAccordions();
    }

    closeAllAccordions() {
      this.accordionToggles.forEach((toggle) => {
        const accordionItem = toggle.closest('[data-accordion-item]');
        if (!accordionItem) return;

        const content = accordionItem.querySelector('[data-accordion-content]');
        const plusIcon = toggle.querySelector('.td-ts__toggle-icon--plus');
        const minusIcon = toggle.querySelector('.td-ts__toggle-icon--minus');

        if (content && plusIcon && minusIcon) {
          toggle.setAttribute('aria-expanded', 'false');
          content.classList.remove('is-expanded');
          plusIcon.classList.remove('is-hidden');
          minusIcon.classList.add('is-hidden');
        }
      });
    }
  }

  customElements.define("td-tab-select", TdTabSelect);
}
